const faqs = [
  {
    q: '古古漫画网的漫画都是免费的吗？',
    a: '是的！古古漫画网所有漫画资源完全免费开放，无需注册会员即可畅享全站内容。我们致力于为漫画爱好者提供零门槛的阅读体验，海量日漫、韩漫、国漫大全随时随地免费看。',
  },
  {
    q: '什么是下拉式阅读？如何使用？',
    a: '下拉式阅读是一种极致流畅的漫画浏览方式，你只需像刷手机一样向下滑动屏幕，漫画内容就会自动连续加载，无需翻页点击。在古古漫画网打开任意漫画，直接下滑即可享受无缝阅读体验，特别适合一口气追完长篇全集。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '古古漫画网每日实时同步各大平台最新连载，平均每日更新超过200话内容。热门作品如《斗破苍穹》《鬼灭之刃》《我独自升级》等基本做到与官方同步更新，让你第一时间追更喜欢的作品。',
  },
  {
    q: '手机和电脑都能看吗？阅读体验如何？',
    a: '当然可以！古古漫画网完美适配手机、平板和电脑端，采用响应式设计。手机端特别优化了下拉式阅读手势操作，高清画质无广告纯净阅读体验，无论在通勤路上还是家中大屏，都能享受最佳的漫画阅读体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            关于古古漫画网的使用方式和平台特点，这里有你想要的答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.q}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <h3 className="font-heading text-sm md:text-base text-foreground-950 mb-2 flex items-start gap-2">
                <span className="text-primary-500 shrink-0 mt-0.5">Q:</span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed flex items-start gap-2 pl-0">
                <span className="text-accent-500 shrink-0 mt-0.5 font-medium">A:</span>
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}